import React, { useCallback, useEffect } from "react";
import { SavedSentence } from "../../models/Sentence";
import { CardComment } from "../../models/Comment";
import PlayerPicture from "../Players/PlayerPicture";
import { PlayerPublic } from "../../models/Player";
import classNames from 'classnames';
import store from "../../store/store";
import useGlobalBodyClick from "../../hooks/useGlobalBodyClick";

export default function RevealedCardData(props: {
  savedSentences: SavedSentence[],
  cardComments: CardComment[],
  ownerPlayerId: string
}) {
  const {
    savedSentences,
    cardComments,
    ownerPlayerId,
  } = props;

  const gameState = store.getState().game;

  const [savedSentencesTooltip, setSavedSentencesTooltip] = React.useState(false);
  const [commentsTooltip, setCommentsTooltip] = React.useState(false);
  const [isLeftAligned, setIsLeftAligned] = React.useState(true);

  const keyPressed = useCallback((event) => {
    switch (event.key) {
      case 'Escape':
        setSavedSentencesTooltip(false);
        setCommentsTooltip(false);
        break;
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    document.addEventListener("keydown", keyPressed, false);

    return () => {
      document.removeEventListener("keydown", keyPressed, false);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function onSavedSentencesClick(e: any) {
    // e.screenX
    setIsLeftAligned(e.pageX >= window.innerWidth / 2);
    setSavedSentencesTooltip(!savedSentencesTooltip);
  }

  function onCommentsClick(e: any) {
    // e.screenX
    setIsLeftAligned(e.pageX >= window.innerWidth / 2);
    setCommentsTooltip(!commentsTooltip);
  }

  useGlobalBodyClick((target: Element) => {
      if (commentsTooltip) {
        setCommentsTooltip(false);
      }
      if (savedSentencesTooltip) {
        setSavedSentencesTooltip(false);
      }
    });

  function getPlayer(playerId: string) {
    return gameState.players.find(it => it.playerId === playerId);
  }

  const classnames = classNames({
    'saved-sentences_content': true,
    'game_tooltip': true,
    'left-aligned': isLeftAligned,
    'right-aligned': !isLeftAligned,
  });

  return (
    <div className="saved-sentences">
      {!!savedSentences?.length && <div className="saved-sentences_icon no-select" onClick={onSavedSentencesClick}>&#9432;</div>}
      {!!cardComments?.length && <div className="saved-sentences_icon no-select" onClick={onCommentsClick}>&#x270E;</div>}
      {savedSentencesTooltip &&
        <div className={classnames}/*  onClick={() => setSavedSentencesTooltip(false)} */>
          <div onClick={() => setSavedSentencesTooltip(false)} className="close_button">×</div>
          {savedSentences && savedSentences.map((it, i) => {

            let failedLabel = '';

            if (!it.score || it.score === 0) {
              if (it.failedAll) {
                failedLabel = 'a';
              }

              if (it.failedNoOne) {
                failedLabel = 'n';
              }
            }

            return <div className="saved-sentence" key={i}>
              {it.picture &&
                <div className="saved-sentence_picture">
                  <PlayerPicture
                    player={{ username: it.username, picture: it.picture } as any as PlayerPublic}
                    size={24}
                    hideInitials={true}
                  />
                </div>
              }
              <div className="saved-sentence_title">
                <div className="saved-sentence_username">{it.username || "-"}</div>
                <div className="saved-sentence_sentence">"{it.sentence}"</div>
              </div>
              <div className="saved-sentence_description">
                {typeof it.score === 'number' &&
                  <div className="saved-sentence_sentence_score">[{it.score}]</div>
                }

                {failedLabel && failedLabel.length &&
                  <div className="saved-sentence_sentence_score-failed">{failedLabel}</div>
                }

                {!!it.likeCount && it.likeCount > 0 &&
                  <div className="saved-sentence_description_likes">
                    <span className="saved-sentence_description_likes_heart">❤️</span>
                    <span className="saved-sentence_description_likes_number">{`${it.likeCount}`}</span>
                  </div>
                }
              </div>
            </div>
          })}
        </div>
      }
      {commentsTooltip &&
        <div className={classnames} /* onClick={() => setCommentsTooltip(false)} */>
          <div onClick={() => setCommentsTooltip(false)} className="close_button">×</div>
          {cardComments && cardComments?.map((it, i) => {

            const player = getPlayer(it.playerId);

            if (!player) {
              return;
            }

            <div className=" ">"{it.comment}"</div>


            const classnames = classNames({
              'saved-sentence_sentence': true,
              'saved-sentence_comment': true,
              'saved-sentence_comment_storyteller': player.isStoryteller,
              'saved-sentence_comment_own': player.playerId === ownerPlayerId,
            });

            return <div className="saved-sentence" key={i}>
              {player.picture &&
                <div className="saved-sentence_picture">
                  <PlayerPicture
                    player={{ username: player.username, picture: player.picture } as any as PlayerPublic}
                    size={24}
                    hideInitials={true}
                  />
                </div>
              }
              <div className="saved-sentence_title">
                <div className="saved-sentence_username">{player.username || "-"}</div>
                <div className={classnames}>"{it.comment}"</div>
              </div>

            </div>
          })}
        </div>
      }

    </div>
  )
}